import React, { FC } from "react";

import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { TModelsListingItemProps } from "../types/ModelsListing.types";

const ModelsListItem: FC<TModelsListingItemProps> = ({ url, item }) => {
  return (
    // TO DO: Replace anchor tag with RoutableSitecoreLink when issue with Layout Service 404 error is fixed
    // <Link field={{value: {href:url}}} className="models-listing__list-item" editable={false}>
    <a href={url} className="models-listing__list-item">
      <img
        src={item.bigthumbnail}
        alt={item.bigthumbnailAlt || ""}
        className="models-listing__list-item__image"
      />
      <div className="models-listing__list-item__details-wrapper">
        <RichText
          field={{ value: item.title }}
          tag="h3"
          className="models-listing__list-item__details-title"
          editable={false}
        />
        <RichText
          field={{ value: item.description }}
          tag="div"
          editable={false}
        />
      </div>
    </a>
    // </Link
  );
};

export default ModelsListItem;
